<template>
    <div class="form-block">
        <h3 class="d-none d-lg-block">Banner image</h3>
        <div class="d-block d-lg-none titlemobile">Banner image</div>
        <div class="fields-container">
            <div class="banner flex-wrap">
                <div v-if="!showInstructions" class="wrap-info-croppa">
                    <h5>Choose an image</h5>
                    <p>Max file size: 1MB. Recommended dimensions: 1300x344 px</p>
                </div>
                <label
                    v-if="url && !edit"
                    for="banner-upload"
                    style="background-image:url('/img/checkboard.png')"
                >
                    <img :src="url" alt="banner" />
                    <i class="material-icons close-btn" @click="edit = true">delete</i>
                </label>
                <croppa
                    placeholder
                    v-else-if="!url || edit"
                    :width="650"
                    :height="172"
                    :show-remove-button="true"
                    :zoom-speed="5"
                    removeButtonColor="#ff5c00"
                    accept=".jpeg, .png, .jpg"
                    :file-size-limit="1000000"
                    ref="croppa"
                    @new-image-drawn="showInstructions = true"
                    @image-remove="showInstructions = false; edit = false; colors='';showColorPicker = false"
                    @file-size-exceed="alert('File size exceeds. Max size: 1MB')"
                    @file-type-mismatch="alert('The file type chosen is not valid')"
                    initial-size="contain"
                    initial-position="center"
                    :canvas-color="canvasColor"
                ></croppa>
                <div v-if="showInstructions" class="wrap-checkboard">
                    <div class="img" style="background-image:url('/img/checkboard.png')"></div>
                </div>
                <div
                    v-if="showInstructions && (!url || edit)"
                    class="instructions"
                >Drag to move and scroll or pinch to zoom</div>
                <!-- <input
                    @change="e => uploadBanner(e.target.files[0])"
                    type="file"
                    name="banner-upload"
                    id="banner-upload"
                    accept="image/*"
                    class="input-file"
                />-->
            </div>
            <a
                v-if="showInstructions"
                href="#"
                @click.prevent="showColorPicker=true"
            >Change background color</a>
            <div v-if="showColorPicker" class="wrap-color-picker">
                <div @click.prevent="showColorPicker=false" class="wrap-close-button">
                    <i class="material-icons">close</i>
                </div>
                <chrome-picker v-model="colors" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "BannerUpload",
    props: ["url"],
    data: () => ({
        showInstructions: false,
        edit: false,
        colors: "",
        showColorPicker: false
    }),
    methods: {
        alert(msg) {
            alert(msg);
        }
    },
    computed: {
        canvasColor() {
            if (!this.colors) {
                return "transparent";
            } else {
                return this.colors.hex8;
            }
        }
    }
};
</script>
<style lang="scss">
.croppa-container {
    border-radius: 5px;
    background-color: white !important;
    border: 2px dashed #979797;
    z-index: 2;
    svg {
        height: 30px !important;
        width: 30px !important;
        top: 15px !important;
        right: 15px !important;
    }
    canvas {
        border-radius: 5px;
    }
}
.banner {
    position: relative;
    .croppa-container {
        background-color: transparent !important;
        canvas {
            width: 100% !important;
            height: auto !important;
        }
    }
}
</style>
<style lang="scss" scoped>
@import "@/assets/scss/_common.scss";
.fields-container {
    position: relative;
    .banner {
        text-align: center;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 100%;
            border: 2px dashed #979797;
            border-radius: 5px;
            object-fit: cover;
        }
        i {
            position: absolute;
            cursor: pointer;
            top: 15px;
            right: 15px;
            font-size: 24px;
            padding: 3px;
            background: white;
            color: $palette-orange;
            border-radius: 50%;
        }
        label {
            z-index: 1;
        }
        .instructions {
            position: absolute;
            background: #97979797;
            padding: 5px 20px;
            font-weight: bolder;
            color: white;
            z-index: 10;
            bottom: 0;
            font-size: 12px;
            color: #fff;
            @media all and (min-width: $size-tablet-portrait) {
                font-size: 16px;
            }
        }
    }
    a {
        margin-top: 8px !important;
    }

    .wrap-color-picker {
        position: relative;
        @media (min-width: 1430px) {
            position: absolute;
            right: -234px;
            z-index: 1;
            top: -28px;
        }
    }

    .wrap-close-button {
        cursor: pointer;
        width: 225px;
        text-align: right;
    }

    .wrap-info-croppa {
        position: absolute;
        z-index: 0;
        h5 {
            font-size: 0.9rem;
            @media all and (min-width: $size-tablet-landscape) {
                font-size: 1.25rem;
            }
        }

        p {
            font-size: 0.7rem;
            margin-bottom: 0;
            @media all and (min-width: $size-tablet-landscape) {
                font-size: 1rem;
            }
        }
    }

    .wrap-checkboard {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1;
        .img {
            object-fit: cover;
            border: none;
            background-repeat: no-repeat;
            width: 100%;
            height: 100%;
        }
    }
}
</style>



